<template>
  <div class="container fi_bg">
    <div class="fi_title">
      <van-row>
        <van-col span="8">
          <div class="fi_title_block">
            <div class="fi_title_block_title">邀请好友</div>
            <div class="fi_title_block_stitle">10位</div>
          </div>
        </van-col>
        <van-col span="8">
          <div class="fi_title_block">
            <div class="fi_title_block_title">到账收益</div>
            <div class="fi_title_block_stitle">￥800</div>
          </div>
        </van-col>
        <van-col span="8">
          <div class="fi_title_block">
            <div class="fi_title_block_title">预计收益</div>
            <div class="fi_title_block_stitle">￥888</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="fi_list">
      <div class="fi_list_title">
        <van-row>
          <van-col span="9">
            <div class="fi_list_title_block1">邀请用户</div>
          </van-col>
          <van-col span="7">
            <div class="fi_list_title_block2">首次开通会员</div>
          </van-col>
          <van-col span="8">
            <div class="fi_list_title_block3">邀请奖励</div>
          </van-col>
        </van-row>
      </div>
      <div class="fi_list_conte">
        <div v-for="(invite_item,invite_index) in list" class="fi_list_block">
          <van-row>
            <van-col span="9">
              <div class="fi_list_block_left">
                <img class="fi_list_block_left_avater" src="https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eouGFWuM06WicPszruPglG5oLYKIIDBBpceuKM5FMIfJvBSySL1cKV8BZI2xFVErtmYGFJh2eC75bQ/132" />
                <div class="fi_list_block_left_text">
                  <div class="fi_list_block_left_text_title">18365285403</div>
                  <div class="fi_list_block_left_text_date">2021.08.21</div>
                </div>
                <div class="clearboth"></div>
              </div>
            </van-col>
            <van-col span="7">
              <div class="fi_list_block_center">
                <div class="fi_list_block_center_viper">砖石会员</div>
                <!-- <div class="fi_list_block_center_unviper">尚未开通</div> -->
              </div>
            </van-col>
            <van-col span="8">
              <div class="fi_list_block_right">
                <!-- <div class="fi_list_block_right_status1">无奖励</div> -->
                <!-- <div class="fi_list_block_right_status2">—</div> -->
                <div class="fi_list_block_right_status3">
                  <!-- <div class="fi_lbrs3_title1">0元</div> -->
                  <div class="fi_lbrs3_title2">+188.88</div>
                  <div class="fi_lbrs3_stitle">已退卡</div>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="fi_list_tips">
        <!-- <label>点击加载更多</label> -->
        <label>已加载全部</label>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        list:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,]
      }
    },
    created() {
      // document.title='邀请记录'
    },
    watch: { },
    
    mounted() { },
    methods: {

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fi_bg{
    background-image: url('../../assets/fx/invite_log_bg.png');
    background-size: 100% auto;
    background-position: left top;
    background-repeat: no-repeat;
  }
  .fi_title{
    width: 100%;
    padding: 72*@vm_base 0 64*@vm_base 0;
    .fi_title_block{
      width: 100%;
      .fi_title_block_title{
        width: 100%;
        font-size: 28*@vm_base;
        font-weight: lighter;
        color: #FBF7F1;
        text-align: center;
      }
      .fi_title_block_stitle{
        width: 100%;
        font-size: 36*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        letter-spacing: 1px;
        padding-top: 24*@vm_base;
      }
    }
  }
  .fi_list{
    width: 100%;
    background: #FFFFFF;
    border-radius: 30*@vm_base 30*@vm_base 0px 0px;
    padding: 40*@vm_base 40*@vm_base 0 40*@vm_base;
    .fi_list_title{
      width: 100%;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #999999;
      .fi_list_title_block1{
        text-align: left;
        line-height: 1;
      }
      .fi_list_title_block2{
        text-align: center;
        line-height: 1;
      }
      .fi_list_title_block3{
        text-align: right;
        line-height: 1;
      }
    }
    .fi_list_conte{
      width: 100%;
    }
    .fi_list_block{
      width: 100%;
      border-bottom: 1*@vm_base solid #E7E7E7;
      .fi_list_block_left{
        height: 184*@vm_base;
        width: 100%;
        padding: 62*@vm_base 0 54*@vm_base 0;
        .fi_list_block_left_avater{
          width: 60*@vm_base;
          height: 60*@vm_base;
          margin-top: 4*@vm_base;
          float: left;
          border-radius: 50%;
        }
        .fi_list_block_left_text{
          width: calc(100% - 60*@vm_base);
          padding-left: 12*@vm_base;
          float: left;
          .fi_list_block_left_text_title{
            width: 100%;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #333333;
            line-height: 1;
            padding-bottom: 20*@vm_base;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

          }
          .fi_list_block_left_text_date{
            width: 100%;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #999999;
            line-height: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .fi_list_block_center{
        height: 184*@vm_base;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .fi_list_block_center_viper{
          font-size: 23*@vm_base;
          font-weight: 400;
          color: #333333;
          padding: 8*@vm_base 18*@vm_base;
          line-height: 1;
          border-radius: 4*@vm_base;
          border: 1*@vm_base solid #BEBEBE;
        }
        .fi_list_block_center_unviper{
          width: 100%;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #333333;
          text-align: center;
        }
      }
      .fi_list_block_right{
        width: 100%;
        height: 184*@vm_base;
        padding: 4*@vm_base 0 0 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .fi_list_block_right_status1{
          width: 100%;
          text-align: right;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #333333;
          line-height: 1;
        }
        .fi_list_block_right_status2{
          width: 100%;
          text-align: right;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #333333;
          line-height: 1;
        }
        .fi_list_block_right_status3{
          width: 100%;
          .fi_lbrs3_title1{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: 400;
            color: #333333;
            line-height: 1;
            text-align: right;
            padding-bottom: 20*@vm_base;
          }
          .fi_lbrs3_title2{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: 400;
            color: #CF4601;
            line-height: 1;
            text-align: right;
            padding-bottom: 20*@vm_base;
          }
          .fi_lbrs3_stitle{
            width: 100%;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #999999;
            line-height: 1;
            text-align: right;
          }
        }
      }
    }
    .fi_list_tips{
      width: 100%;
      height: 147*@vm_base;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #333333;
      label{
        padding: 10*@vm_base 20*@vm_base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/fxviews/fxmyinvite/fxmyinvite.vue